import CircularProgress from '@material-ui/core/CircularProgress'
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined'
import { styled } from 'opensolar-ui'
import { memo } from 'react'

const Container = styled('div')({
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: -14,
  padding: 1,
})

const StyledCircularProgress = styled(CircularProgress)({
  width: 25,
  height: 25,
  marginRight: 10,
})

const SearchIcon = styled(SearchOutlinedIcon, { name: 'SearchIcon' })<{
  shop3: boolean
}>(({ shop3, theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 45,
  height: 40,
  maxHeight: 40,
  flexGrow: 0,
  flexShrink: 0,
  boxSizing: 'border-box',
  cursor: 'pointer',
  color: shop3 ? 'white' : theme.palette.primary.contrastText,
  background: shop3 ? theme.palette.blue[800] : theme.palette.primary.main,
  borderTopRightRadius: 4,
  borderBottomRightRadius: 4,
  padding: 4,
}))

const SearchBarEndAdornment = ({
  loading,
  onSearchIconClicked,
  shop3,
}: {
  loading: boolean
  onSearchIconClicked(): void
  shop3?: boolean
}) => {
  return (
    <Container>
      {loading && <StyledCircularProgress size={'small'} />}
      <SearchIcon shop3={!!shop3} onClick={onSearchIconClicked} />
    </Container>
  )
}

export default memo(SearchBarEndAdornment)
